import type { McpPrompt, McpServer, UpsertMcpServerInput } from "@codvero/shared";
import { api, del, get, post } from "./client.ts";

/** The user's MCP connections for the Chat section (secret values are write-only). */
export const mcpApi = {
  list: () => get<McpServer[]>("/api/mcp-servers"),
  create: (input: UpsertMcpServerInput) => post<McpServer>("/api/mcp-servers", input),
  update: (id: string, input: UpsertMcpServerInput) => api<McpServer>(`/api/mcp-servers/${id}`, { method: "PUT", json: input }),
  remove: (id: string) => del(`/api/mcp-servers/${id}`),
  /** A remote server's shortcuts (MCP prompts) and one shortcut's text. */
  prompts: (id: string) => get<McpPrompt[]>(`/api/mcp-servers/${id}/prompts`),
  prompt: (id: string, name: string, args: Record<string, string>) => post<{ text: string }>(`/api/mcp-servers/${id}/prompts/get`, { name, arguments: args }),
  /** Remote servers that ask for an account: the login page to open, and forgetting the account. */
  oauthStart: (id: string) => post<{ url: string }>(`/api/mcp-servers/${id}/oauth/start`),
  oauthDisconnect: (id: string) => post<McpServer>(`/api/mcp-servers/${id}/oauth/disconnect`),
};
